"use strict";
exports.__esModule = true;
exports.DisbursementStatus = exports.BankAccountType = exports.CheckMethod = exports.DisbursementMethod = exports.DisbursementType = exports.TaxType = exports.DisbursementCountry = void 0;
var DisbursementCountry;
(function (DisbursementCountry) {
    DisbursementCountry["USA"] = "usa";
    DisbursementCountry["Mexico"] = "mexico";
    DisbursementCountry["Canada"] = "canada";
    DisbursementCountry["Other"] = "other";
})(DisbursementCountry = exports.DisbursementCountry || (exports.DisbursementCountry = {}));
var TaxType;
(function (TaxType) {
    TaxType["PreTax"] = "preTax";
    TaxType["Roth"] = "roth";
    TaxType["AfterTax"] = "afterTax";
})(TaxType = exports.TaxType || (exports.TaxType = {}));
var DisbursementType;
(function (DisbursementType) {
    DisbursementType["Full"] = "full";
    DisbursementType["Partial"] = "partial";
    DisbursementType["Recurring"] = "recurring";
    DisbursementType["Loan"] = "loan";
    DisbursementType["ForceOut"] = "forceout";
    DisbursementType["PaymentOnly"] = "paymentOnly";
})(DisbursementType = exports.DisbursementType || (exports.DisbursementType = {}));
var DisbursementMethod;
(function (DisbursementMethod) {
    DisbursementMethod["Ach"] = "ach";
    DisbursementMethod["Check"] = "check";
    DisbursementMethod["Wire"] = "wire";
    DisbursementMethod["ForceOut"] = "forceout";
    DisbursementMethod["None"] = "none";
})(DisbursementMethod = exports.DisbursementMethod || (exports.DisbursementMethod = {}));
var CheckMethod;
(function (CheckMethod) {
    CheckMethod["Standard"] = "standard";
    CheckMethod["FedEx"] = "fedEx";
})(CheckMethod = exports.CheckMethod || (exports.CheckMethod = {}));
var BankAccountType;
(function (BankAccountType) {
    BankAccountType["Checking"] = "checking";
    BankAccountType["Savings"] = "savings";
})(BankAccountType = exports.BankAccountType || (exports.BankAccountType = {}));
var DisbursementStatus;
(function (DisbursementStatus) {
    DisbursementStatus["PENDING"] = "pending";
    DisbursementStatus["CONFIRMED"] = "confirmed";
    DisbursementStatus["REJECTED"] = "rejected";
    DisbursementStatus["OUTSTANDING"] = "outstanding";
    DisbursementStatus["CLEARED"] = "cleared";
    DisbursementStatus["STOPPED"] = "stopped";
    DisbursementStatus["REISSUED"] = "reissued";
    DisbursementStatus["NO_DISBURSEMENT"] = "noDisbursement";
    DisbursementStatus["CASHED"] = "cashed";
    DisbursementStatus["DISBURSEMENT_REVERSED"] = "disbursementReversed";
    DisbursementStatus["STOP_REQUEST_PENDING"] = "stopRequestPending";
})(DisbursementStatus = exports.DisbursementStatus || (exports.DisbursementStatus = {}));
